/* eslint-disable */
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import saveStoreDraft from "../../../utils/saveStoreDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "../../../components/worker/sidebar/SidebarWorker";
import Navbar from "../../../components/worker/navbar/Navbar2";
import Footer from "../../../components/footer/Footer";
import Spinner from "react-bootstrap/Spinner";
import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../firebase";
import { getAuth, updatePassword } from "firebase/auth";
import { logoutUser } from "../../../redux/user/user";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Tooltip } from "antd";
import { Languages } from "lucide-react";
import i18n from "../../../i18n";
import { reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import {
  User,
  Phone,
  Mail,
  Calendar,
  Lock,
  Save,
  Monitor,
  Smartphone,
  MapPin,
  Clock,
  LogOut,
  KeySquare,
  SquareAsterisk,
  Camera,
  Upload,
  Loader2 as Loader2Icon,
  X,
  Info,
} from "lucide-react";
import IdentityVerification from "./verifyIdentity";
import { useTranslation } from "react-i18next";
import ContactSettings from "./ContactSettings";
import axios from "axios";

function Account() {
  const account = useSelector((state) => state.AccountReducer);
  const worker = useSelector((state) => state.workerReducer);
  const currentLang = account.language || "ar";
  const MySwal = withReactContent(Swal);
  const dispatch = useDispatch();
  const auth = getAuth();
  const user = auth.currentUser;
  const [showSideBar, setShowSideBar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [data, setData] = useStoreFormDraft(worker);
  const [activeStep, setActiveStep] = useState(1);
  const [qrCode, setQrCode] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);

  const [data2, setData2] = useState({
    oldPassword: "",
    password: "",
    passwordConfirmation: "",
  });
  const [activeTab, setActiveTab] = useState("tab1");
  const { t, i18n } = useTranslation();
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [photoPreview, setPhotoPreview] = useState("");

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setPhotoPreview(worker?.photoUrl || "");
  }, [worker]);

  const handlePhotoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validation du type de fichier
    if (!file.type.startsWith("image/")) {
      Swal.fire({
        icon: "warning",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("workersManagement.inviteWorkerModal.invalidFileType"),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    // Validation de la taille (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire({
        icon: "warning",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("workersManagement.inviteWorkerModal.fileTooLarge"),
        confirmButtonColor: "#9b59bf",
      });
      return;
    }

    setUploadingPhoto(true);

    try {
      // Prévisualisation locale
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(file);

      // Upload vers le serveur
      const formData = new FormData();
      formData.append("upload", file, `${Date.now()}-${file.name}`);

      const response = await axios.post(
        "https://octopus-app-i4ylg.ondigitalocean.app/upload",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.url) {
        setData((prev) => ({ ...prev, photoUrl: response.data.url }));

        // Mise à jour directe dans Firestore
        await updateDoc(doc(db, "workers", data.id), {
          photoUrl: response.data.url
        });

        Swal.fire({
          icon: "success",
          title: t("ui.photoUpdated"),
          text: t("ui.photoUpdatedHint"),
          confirmButtonColor: "#9b59bf",
          timer: 2000,
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      Swal.fire({
        icon: "error",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("workersManagement.inviteWorkerModal.uploadError"),
        confirmButtonColor: "#9b59bf",
      });
      setPhotoPreview(data?.photoUrl || "");
    } finally {
      setUploadingPhoto(false);
    }
  };

  const removePhoto = async () => {
    try {
      const result = await Swal.fire({
        icon: "question",
        title: t("ui.deletePhotoTitle"),
        text: t("ui.deletePhotoConfirm"),
        showCancelButton: true,
        confirmButtonText: t("cashBack.swal.deleteConfirm.confirm"),
        cancelButtonText: t("annule"),
        confirmButtonColor: "#9b59bf",
        cancelButtonColor: "#d33",
      });

      if (result.isConfirmed) {
        setData((prev) => ({ ...prev, photoUrl: "" }));
        setPhotoPreview("");

        await updateDoc(doc(db, "workers", data.id), {
          photoUrl: ""
        });

        Swal.fire({
          icon: "success",
          title: t("ui.photoDeleted"),
          text: t("ui.photoDeletedHint"),
          confirmButtonColor: "#9b59bf",
          timer: 2000,
        });
      }
    } catch (error) {
      console.error("Error removing photo:", error);
      Swal.fire({
        icon: "error",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("ui.photoDeleteError"),
        confirmButtonColor: "#9b59bf",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveStoreDraft(doc(db, "workers", data.id), worker, data);
      Swal.fire({
        icon: "success",
        title: t("AccountSettings.alerts.save_success.title"),
        confirmButtonText: t("AccountSettings.alerts.save_success.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("AccountSettings.alerts.save_error.text"),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();

    if (data2.password.length < 6) {
      return MySwal.fire({
        icon: "warning",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("AccountSettings.alerts.password.too_short"),
        confirmButtonColor: "#9b59bf",
      });
    }

    if (data2.password !== data2.passwordConfirmation) {
      return MySwal.fire({
        icon: "warning",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("AccountSettings.alerts.password.mismatch"),
        confirmButtonColor: "#9b59bf",
      });
    }

    setPasswordLoading(true);

    try {
      const credential = EmailAuthProvider.credential(
        user.email,
        data2.oldPassword
      );

      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, data2.password);

      dispatch(logoutUser(""));
      localStorage.setItem("token", "");

      MySwal.fire({
        icon: "success",
        title: t("AccountSettings.alerts.password.change_success"),
        confirmButtonText: t("AccountSettings.alerts.save_error.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      console.error("Error during password change:", error);
      MySwal.fire({
        icon: "error",
        title: t("AccountSettings.alerts.save_error.title"),
        text: t("AccountSettings.alerts.password.wrong_old"),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setPasswordLoading(false);
    }
  };

  const getDeviceImage = (deviceName) => {
    if (deviceName.includes("Windows")) {
      return "https://cdn-icons-png.flaticon.com/512/2504/2504927.png";
    }
    if (deviceName.includes("iPhone") || deviceName.includes("iOS")) {
      return "https://cdn-icons-png.flaticon.com/512/14776/14776639.png";
    }
    if (deviceName.includes("Android")) {
      return "https://cdn-icons-png.flaticon.com/128/2504/2504881.png";
    }
    return "https://cdn-icons-png.flaticon.com/512/1251/1251009.png";
  };

  const showDevicesModal = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleDeleteDevice = async (deviceName) => {
    try {
      const result = await Swal.fire({
        icon: "question",
        title: t("AccountSettings.alerts.device.confirm_logout_title"),
        text: t("AccountSettings.alerts.device.confirm_logout_text"),
        showCancelButton: true,
        confirmButtonText: t("AccountSettings.alerts.device.confirm"),
        cancelButtonText: t("AccountSettings.alerts.device.cancel"),
        confirmButtonColor: "#9b59bf",
        cancelButtonColor: "#d33",
      });

      if (result.isConfirmed) {
        const deviceToUpdate = devices.find(
          (device) => device.deviceName === deviceName
        );

        if (deviceToUpdate) {
          deviceToUpdate.isLoggedIn = false;

          await setDoc(
            doc(db, "workers", account.id),
            {
              devices: devices.map((device) =>
                device.deviceName === deviceName ? deviceToUpdate : device
              ),
            },
            { merge: true }
          );

          const updatedDevices = devices.map((device) =>
            device.deviceName === deviceName ? deviceToUpdate : device
          );
          setDevices(updatedDevices);

          Swal.fire({
            icon: "success",
            title: t("AccountSettings.alerts.device.logout_success"),
            showConfirmButton: false,
            timer: 1500,
            confirmButtonColor: "#9b59bf",
          });
        }
      }
    } catch (error) {
      console.error("Error deleting device:", error);
    }
  };

  // Generate secret key and QR code
  useEffect(() => {
    generateSecretKey();
    loadDevices();
  }, []);

  const generateSecretKey = async () => {
    try {
      const res = await fetch(
        `https://backend-digital.foorweb.store/api/generateSecret?email=${account?.email}`
      );
      const data = await res.json();

      if (data.success) {
        setSecretKey(data.secret);
        setQrCode(data.qrUrl);
      }
    } catch (error) {
      console.error("Error generating secret:", error);
    }
  };

  const loadDevices = () => {
    setDevices(worker.devices);
  };

  const getDeviceIcon = (deviceName) => {
    if (deviceName.toLowerCase().includes("iphone")) return "📱";
    if (deviceName.toLowerCase().includes("macbook")) return "💻";
    if (deviceName.toLowerCase().includes("android")) return "📱";
    return "🖥️";
  };

  const isRTL = i18n.language === "ar";
  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("AccountSettings.page_title")}
                </h2>
                <p className="text-gray-600 mb-0">
                  {t("AccountSettings.page_subtitle")}
                </p>
              </div>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white dark:!border-[#3c3a3d] dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] overflow-hidden">
              <div className="flex">
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "tab1"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade] "
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                    }`}
                  onClick={() => setActiveTab("tab1")}
                >
                  {t("AccountSettings.tabs.account_info")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "tab2"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade]"
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                    }`}
                  onClick={() => setActiveTab("tab2")}
                >
                  {t("AccountSettings.tabs.change_password")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${activeTab === "tab3"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade]"
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                    }`}
                  onClick={() => setActiveTab("tab3")}
                >
                  {t("AccountSettings.tabs.connected_devices")}
                </button>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="mx-3 mb-6">
            {/* Account Info Tab */}
            {activeTab === "tab1" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <User size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800  dark:text-gray-300">
                    {t("AccountSettings.account_info.title")}
                  </h3>
                </div>

                <form onSubmit={handleSubmit} className="space-y-8">
                  {/* Photo de profil - Design amélioré */}
                  <div className="mb-10 flex justify-center">
                    <div className="text-center">
                      <label className="block text-sm font-semibold text-[#9e68ba] dark:text-purple-400 mb-4 tracking-wide uppercase">
                        <Camera size={16} className="inline mr-2" />
                        {t("AccountSettings.account_info.photo.label") || t("AccountSettings.account_info.photo.label")}
                      </label>

                      <div className="relative inline-block">
                        {photoPreview || data?.photoUrl ? (
                          <div className="relative group">
                            {/* Photo */}
                            <div className="relative w-36 h-36 rounded-full overflow-hidden ring-4 ring-purple-200 dark:ring-purple-800 shadow-xl">
                              <img
                                src={photoPreview || data?.photoUrl}
                                alt={t("ui.profile")}
                                className="w-full h-full object-cover"
                              />
                            </div>

                            {/* Indicateur de chargement */}
                            {uploadingPhoto && (
                              <div className="absolute inset-0 bg-black/50 rounded-full flex items-center justify-center backdrop-blur-sm">
                                <div className="bg-white/90 rounded-full p-3 shadow-xl">
                                  <Spinner animation="border" variant="purple" size="sm" />
                                </div>
                              </div>
                            )}

                            {/* Boutons d'action - Toujours visibles */}
                            {!uploadingPhoto && (
                              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-2">
                                <label className="cursor-pointer bg-purple-600 hover:bg-purple-700 p-2.5 rounded-full shadow-lg transform hover:scale-110 transition-all duration-200">
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handlePhotoUpload}
                                    className="hidden"
                                  />
                                  <Camera size={16} className="text-white" />
                                </label>
                                <button
                                  type="button"
                                  onClick={removePhoto}
                                  className="bg-red-500 hover:bg-red-600 p-2.5 rounded-full shadow-lg transform hover:scale-110 transition-all duration-200"
                                >
                                  <X size={16} className="text-white" />
                                </button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <label className="relative cursor-pointer group block">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handlePhotoUpload}
                              disabled={uploadingPhoto}
                              className="hidden"
                            />

                            {/* Zone de téléchargement avec design moderne */}
                            <div className="relative w-36 h-36 rounded-full overflow-hidden">
                              <div className="absolute inset-0 bg-gradient-to-br from-purple-400 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                              <div className="absolute inset-0 bg-gray-100 dark:bg-[#2a2a2a] border-2 border-dashed border-gray-300 dark:border-gray-600 group-hover:border-purple-400 dark:group-hover:border-purple-500 transition-all duration-300 flex flex-col items-center justify-center group-hover:bg-purple-50 dark:group-hover:bg-purple-900/20">
                                {uploadingPhoto ? (
                                  <div className="flex flex-col items-center gap-2">
                                    <Spinner animation="border" variant="purple" size="sm" />
                                    <span className="text-xs text-purple-600 font-medium">
                                      {t("ui.uploading")}
                                    </span>
                                  </div>
                                ) : (
                                  <>
                                    <Upload size={32} className="text-gray-400 group-hover:text-purple-500 mb-2 transition-colors" />
                                    <span className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-purple-600 font-medium px-2 text-center">
                                      {t("AccountSettings.account_info.photo.upload") || t("AccountSettings.account_info.photo.upload")}
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </label>
                        )}
                      </div>

                      {/* Indication format avec icône */}
                      <p className="flex items-center justify-center gap-2 text-xs text-gray-500 dark:text-gray-400 mt-4">
                        <Info size={14} />
                        {t("AccountSettings.account_info.photo.hint") || t("AccountSettings.account_info.photo.hint")}
                      </p>
                    </div>
                  </div>

                  {/* Champs du formulaire avec design amélioré */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Nom complet */}
                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-sm font-semibold text-[#9e68ba] dark:text-purple-400">
                        <User size={16} />
                        {t("AccountSettings.account_info.name.label")}
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          value={data.name || ""}
                          onChange={(e) => setData({ ...data, name: e.target.value })}
                          className="w-full px-4 py-3 bg-white dark:!bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] rounded-xl text-gray-900 dark:text-gray-200 placeholder-gray-400 focus:ring-2 focus:ring-purple-200 focus:border-purple-500 transition-all duration-200"
                          placeholder={t("AccountSettings.account_info.name.placeholder")}
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                          <User size={16} className="text-gray-400" />
                        </div>
                      </div>
                    </div>

                    {/* Téléphone */}
                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-sm font-semibold text-[#9e68ba] dark:text-purple-400">
                        <Phone size={16} />
                        {t("AccountSettings.account_info.phone.label")}
                      </label>
                      <div className="relative">
                        <input
                          type="tel"
                          value={data.phone || ""}
                          onChange={(e) => setData({ ...data, phone: e.target.value })}
                          className="w-full px-4 py-3 bg-white dark:!bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] rounded-xl text-gray-900 dark:text-gray-200 placeholder-gray-400 focus:ring-2 focus:ring-purple-200 focus:border-purple-500 transition-all duration-200"
                          placeholder={t("AccountSettings.account_info.phone.label")}
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                          <Phone size={16} className="text-gray-400" />
                        </div>
                      </div>
                    </div>

                    {/* Email (désactivé) */}
                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-sm font-semibold text-[#9e68ba] dark:text-purple-400">
                        <Mail size={16} />
                        {t("AccountSettings.account_info.email.label")}
                      </label>
                      <div className="relative">
                        <input
                          type="email"
                          value={data.email || ""}
                          disabled
                          className="w-full px-4 py-3 bg-gray-50 dark:bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] rounded-xl text-gray-500 dark:text-gray-400 cursor-not-allowed"
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                          <Mail size={16} className="text-gray-400" />
                        </div>
                      </div>
                    </div>

                    {/* Date de naissance */}
                    <div className="space-y-2">
                      <label className="flex items-center gap-2 text-sm font-semibold text-[#9e68ba] dark:text-purple-400">
                        <Calendar size={16} />
                        {t("AccountSettings.account_info.birth.label")}
                      </label>
                      <div className="relative">
                        <input
                          type="date"
                          value={data.birthDay || ""}
                          onChange={(e) => setData({ ...data, birthDay: e.target.value })}
                          className="w-full px-4 py-3 bg-white dark:!bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] rounded-xl text-gray-900 dark:text-gray-200 focus:ring-2 focus:ring-purple-200 focus:border-purple-500 transition-all duration-200"
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <Calendar size={16} className="text-gray-400" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Bouton de sauvegarde amélioré */}
                  <div className="flex justify-end pt-4 border-t border-gray-200 dark:border-[#3c3a3d]">
                    <button
                      type="submit"
                      className="group relative flex items-center gap-3 bg-gradient-to-r from-[#9b59bf] to-[#8e44ad] hover:from-[#8e44ad] hover:to-[#9b59bf] text-white font-semibold py-3 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200 disabled:opacity-50 disabled:pointer-events-none overflow-hidden"
                      disabled={loading}
                    >
                      {/* Effet de brillance */}
                      <div className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700" />

                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" />
                          <span>{t("AccountSettings.saving")}</span>
                        </>
                      ) : (
                        <>
                          <Save size={20} />
                          <span>{t("AccountSettings.save_button")}</span>
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Password Change Tab */}
            {activeTab === "tab2" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex items-center mb-6">
                  <Lock size={20} className="text-[#9e68ba] ml-2" />
                  <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                    {t("AccountSettings.change_password.title")}
                  </h3>
                </div>

                <form onSubmit={handleSubmit2}>
                  <div className="mb-6">
                    <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                      {t("AccountSettings.change_password.old")}
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <KeySquare size={16} className="text-gray-400" />
                      </div>
                      <input
                        type="password"
                        placeholder={t("AccountSettings.change_password.old")}
                        value={data2.oldPassword}
                        onChange={(e) =>
                          setData2({
                            ...data2,
                            oldPassword: e.target.value,
                          })
                        }
                        className="bg-white dark:!bg-[#181819] dark:!text-[#3c3ad] dark:!text-gray-400 border border-gray-300 dark:!border-[#3c3a3d] text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500  p-2.5  focus:outline-none focus:ring-2 "
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("AccountSettings.change_password.new")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <SquareAsterisk size={16} className="text-gray-400" />
                        </div>
                        <input
                          type="password"
                          placeholder={t("AccountSettings.change_password.new")}
                          value={data2.password}
                          onChange={(e) =>
                            setData2({ ...data2, password: e.target.value })
                          }
                          className={`bg-white border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-[#3c3ad] dark:!text-gray-400 text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500  p-2.5  focus:outline-none focus:ring-2  ${data2.password.length > 0 &&
                              data2.password.length < 6
                              ? "border-red-300"
                              : "border-gray-300"
                            }`}
                          required
                        />
                        {data2.password.length > 0 &&
                          data2.password.length < 6 && (
                            <p className="mt-1 text-sm text-red-500">
                              {t("AccountSettings.change_password.too_short")}
                            </p>
                          )}
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("AccountSettings.change_password.confirm")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <SquareAsterisk size={16} className="text-gray-400" />
                        </div>
                        <input
                          type="password"
                          placeholder={t(
                            "AccountSettings.change_password.confirm"
                          )}
                          value={data2.passwordConfirmation}
                          onChange={(e) =>
                            setData2({
                              ...data2,
                              passwordConfirmation: e.target.value,
                            })
                          }
                          className={`bg-white border border-gray-300 dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-[#3c3ad] text-gray-900 text-sm rounded-lg block w-full py-3 pl-10 pr-10 focus:ring-purple-200 focus:border-purple-500  p-2.5  focus:outline-none focus:ring-2  ${data2.passwordConfirmation.length > 0 &&
                              data2.password !== data2.passwordConfirmation
                              ? "border-red-300"
                              : "border-gray-300"
                            }`}
                          required
                        />
                        {data2.passwordConfirmation.length > 0 &&
                          data2.password !== data2.passwordConfirmation && (
                            <p className="mt-1 text-sm text-red-500">
                              {t("AccountSettings.change_password.not_match")}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:pointer-events-none"
                      disabled={
                        passwordLoading ||
                        data2.oldPassword.length === 0 ||
                        data2.password.length < 6 ||
                        data2.password !== data2.passwordConfirmation
                      }
                    >
                      {passwordLoading ? (
                        <>
                          <Spinner animation="border" size="sm" />
                          <span className="mr-1">
                            {t("AccountSettings.saving")}
                          </span>
                        </>
                      ) : (
                        <>
                          <Save size={18} />
                          <span className="mr-1">
                            {t("AccountSettings.change_password.button")}
                          </span>
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* Connected Devices Tab */}
            {activeTab === "tab3" && (
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-gray-700">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center">
                    <Monitor size={20} className="text-[#9e68ba] ml-2" />
                    <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-100">
                      {t("AccountSettings.connected_devices.title")}
                    </h3>
                  </div>
                  <div>
                    <Tooltip title={t("AccountSettings.connected_devices.active_devices_count_tooltip")}>
                      <span className="inline-flex items-center justify-center px-3 py-1 text-xs font-medium rounded-full bg-purple-100 dark:!bg-purple-900 text-[#9e65bb] dark:!text-purple-300">
                        {devices?.filter((d) => d.isLoggedIn === true)
                          ?.length || 0}{" "}
                        {devices?.filter((d) => d.isLoggedIn === true)?.length === 1
                          ? t("AccountSettings.connected_devices.device_count_label")
                          : t("AccountSettings.connected_devices.device_count_plural")}
                      </span>
                    </Tooltip>
                  </div>
                </div>

                <p className="text-gray-600 dark:!text-gray-400 mb-6">
                  {t("AccountSettings.connected_devices.description")}
                </p>

                {Array.isArray(devices) &&
                  devices.filter((d) => d.isLoggedIn === true).length > 0 ? (
                  <div className="space-y-4">
                    {devices
                      .filter((device) => device.isLoggedIn === true)
                      .map((device) => (
                        <div
                          key={device.deviceName}
                          className="flex items-center justify-between p-4 border border-gray-200 dark:!border-gray-700 rounded-lg hover:border-purple-200 dark:!hover:border-purple-500 transition-colors bg-white dark:!bg-[#242426]"
                        >
                          <div className="flex items-center gap-4">
                            <div className="h-10 w-10 rounded-full bg-[#fcf6ff] dark:!bg-purple-900 p-1 flex items-center justify-center">
                              <img
                                src={getDeviceImage(device.deviceName)}
                                className="h-7 w-7 object-contain"
                                alt={device.deviceName}
                              />
                            </div>
                            <div>
                              <h4 className="font-medium text-gray-900 dark:!text-gray-100">
                                {device.deviceName}
                              </h4>
                              <div className="text-sm text-gray-500 dark:!text-gray-400 space-y-1">
                                <div className="flex items-center gap-1">
                                  <Clock size={14} />
                                  <span>
                                    {t("AccountSettings.connected_devices.last_active")}:{" "}
                                    {device.timestamp && device.timestamp.toDate
                                      ? new Date(
                                        device.timestamp.seconds * 1000
                                      ).toLocaleString()
                                      : t("AccountSettings.connected_devices.unavailable")}
                                  </span>
                                </div>
                                {device.location && (
                                  <div className="flex items-center gap-1">
                                    <MapPin size={14} />
                                    <span>
                                      {device.location.country &&
                                        device.location.region
                                        ? `${device.location.region} - ${device.location.country}`
                                        : t("AccountSettings.connected_devices.location_unavailable")}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <button
                            onClick={() =>
                              handleDeleteDevice(device.deviceName)
                            }
                            className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 dark:!bg-gray-700 hover:bg-red-50 dark:!hover:bg-red-900 text-gray-700 dark:!text-gray-300 hover:text-red-600 dark:!hover:text-red-400 rounded-lg transition-colors text-sm"
                          >
                            <LogOut size={16} />
                            <span>{t("AccountSettings.connected_devices.logout_button")}</span>
                          </button>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="bg-gray-50 dark:!bg-[#242426] p-6 rounded-lg text-center">
                    <div className="w-16 h-16 bg-gray-100 dark:!bg-gray-700 rounded-full mx-auto flex items-center justify-center mb-4">
                      <Smartphone size={24} className="text-gray-400 dark:!text-gray-500" />
                    </div>
                    <h4 className="text-gray-700 dark:!text-gray-300 font-medium mb-2">
                      {t("AccountSettings.connected_devices.no_devices.title")}
                    </h4>
                    <p className="text-gray-500 dark:!text-gray-400 text-sm">
                      {t("AccountSettings.connected_devices.no_devices.description")}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Account;
